/**
 * Formats time in seconds to a human-readable display string.
 * Examples:
 * - 1200 seconds (20 minutes) -> "20 minutes"
 * - 3600 seconds (1 hour) -> "1 hour"
 * - 5400 seconds (1.5 hours) -> "1 hour 30 minutes"
 * - 7200 seconds (2 hours) -> "2 hours"
 * 
 * @param {number} seconds - Time in seconds
 * @param {Function} t - Translation function from i18next
 * @returns {string} Formatted time string
 */
export function formatDisplayTime(seconds, t) {
  if (seconds < 0) return '0 ' + t('common.minutes');
  if (seconds === 0) return '0 ' + t('common.minutes');
  
  const totalMinutes = Math.floor(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  
  // If less than 60 minutes, just show minutes
  if (hours === 0) {
    return `${totalMinutes} ${totalMinutes === 1 ? t('common.minute') : t('common.minutes')}`;
  }
  
  // If exactly on the hour (no minutes), just show hours
  if (minutes === 0) {
    return `${hours} ${hours === 1 ? t('common.hour') : t('common.hours')}`;
  }
  
  // Otherwise show both hours and minutes
  const hoursText = `${hours} ${hours === 1 ? t('common.hour') : t('common.hours')}`;
  const minutesText = `${minutes} ${minutes === 1 ? t('common.minute') : t('common.minutes')}`;
  
  return `${hoursText} ${minutesText}`;
}

